<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import type { PatternTransformParams } from './../pattern/pattern-transformer';
  import { round } from '../helpers';

  import { Button, Col, Icon, Row, TextField } from 'svelte-materialify/src';
  import { 
    mdiArrowLeft, 
    mdiArrowRight, 
    mdiFlipHorizontal,
    mdiFlipVertical, 
    mdiSpeedometer, 
    mdiSpeedometerSlow,
    mdiUndo
  } from '@mdi/js';   
 

  export let patternTransformParams: PatternTransformParams;

  let phaseStep: number = 0.25;

  const dispatch = createEventDispatcher();

  const reinitializePattern = () => {
    dispatch('updatePatternTransformParams');
  };

  const decreaseSpeed = () => {
    patternTransformParams.scratchSpeed /= 2;
    reinitializePattern();
  };
  const increaseSpeed = () => {
    patternTransformParams.scratchSpeed *= 2;
    reinitializePattern();
  };

  const phaseLeft = () => {
    patternTransformParams.phasing -= phaseStep;
    reinitializePattern();
  };
  const phaseRight = () => {
    patternTransformParams.phasing += phaseStep;
    reinitializePattern();
  };
  const updatePhaseStep = (ev: Event) => {
    console.log('phaseStep:', ev.target.value, typeof ev.target.value);
    phaseStep = ev.target.value;
  }

  const toggleFlipVertical = () => {
    patternTransformParams.flipVertically = !patternTransformParams.flipVertically;
    reinitializePattern();
  };
  const toggleFlipHorizontal = () => {
    patternTransformParams.flipHorizontal = !patternTransformParams.flipHorizontal;
    reinitializePattern();
  };

  const resetAllTransformations = () => {
    dispatch('resetPatternTransformParams');
  };
  
</script>


<Row dense>
  <Col cols={12} sm={6} md={4}>
    <Button icon title="Phase to left" on:click={phaseLeft}>
      <Icon path={mdiArrowLeft} />
    </Button>
    <span class="{patternTransformParams.phasing != 0 ? 'primary-text' : ''}">
      Phase by {phaseStep} <!-- configurable phasing step commented out, some bug "NaN" -->
<!--      <TextField type="number" dense -->
<!--        value={phaseStep.toString()} on:change={updatePhaseStep}-->
<!--        min=0 max=1-->
<!--        style="display: inline-block;"-->
<!--      ></TextField>-->
      ({round(patternTransformParams.phasing, 3)})
    </span>
    <Button icon title="Phase to right" on:click={phaseRight}>
      <Icon path={mdiArrowRight} />
    </Button>
  </Col>

  <Col cols={12} sm={6} md={3}>
    <Button icon title="Flip horizontal" on:click={toggleFlipHorizontal}
      class="{patternTransformParams.flipHorizontal ? 'primary-text' : ''}">
      <Icon path={mdiFlipHorizontal} />
    </Button>
    Flip
    <Button icon title="Flip vertical" on:click={toggleFlipVertical}
      class="{patternTransformParams.flipVertically ? 'primary-text' : ''}">
      <Icon path={mdiFlipVertical} />
    </Button>
  </Col>

  <Col cols={10} sm={6} md={4}>
    <Button icon title="Half time" on:click={decreaseSpeed}>
      <Icon path={mdiSpeedometerSlow} />
    </Button>
    <span class="{patternTransformParams.scratchSpeed != 1 ? 'primary-text' : ''}">
      Skratch speed ({patternTransformParams.scratchSpeed}x)
    </span>
    <Button icon title="Double time" on:click={increaseSpeed}>
      <Icon path={mdiSpeedometer} />
    </Button>
  </Col>  

  <Col cols={2}  md={1} class="text-sm-right">
    <Button icon disabled={!patternTransformParams.hasChanges}
      title="Reset all transformations" on:click={resetAllTransformations}>
      <Icon path={mdiUndo} />
    </Button>
  </Col>

</Row>
